import React, { Component, Fragment } from "react";
import { connect } from "react-redux";

import { Field } from "react-final-form";
import { required } from "modules/4_final_form/web";

import { getProjectQaWeldingInspectionsWeldingTypes } from "modules/project/qa/welding_inspections/welding_types/actions";
import { getProjectQaWeldingInspectionsWeldingProcesses } from "modules/project/qa/welding_inspections/welding_processes/actions";
import { getProjectQaWeldingInspectionsWeldingStages } from "modules/project/qa/welding_inspections/welding_stages/actions";
import { getProjectQaWeldingInspectionsWeldingStandards } from "modules/project/qa/welding_inspections/welding_standards/actions";

import { getProjectQaWeldingInspectionsAccessRestrictions } from "modules/project/qa/welding_inspections/access_restrictions/actions";
import { getProjectQaWeldingInspectionsViewingConditions } from "modules/project/qa/welding_inspections/viewing_conditions/actions";
import { getProjectQaWeldingInspectionsSurfaceConditions } from "modules/project/qa/welding_inspections/surface_conditions/actions";
import { getProjectQaWeldingInspectionsFilletSizes } from "modules/project/qa/welding_inspections/fillet_sizes/actions";

import { getEmployees } from "modules/employees/actions";
import { getProjectQaWeldingInspectionsWeldingProcedures } from "modules/project/qa/welding_inspections/welding_procedures/actions.js";

import { OnChange } from "react-final-form-listeners";
import { BlockTitle, List } from "framework7-react";
import { SmartSelect } from "modules/4_final_form/mobile";

const mapStateToProps = (state) => {
  return {
    employees: _.orderBy(state.employees, ["last_name", "first_name"]),
    project_qa_welding_inspections_welding_procedures: _.orderBy(state.project_qa_welding_inspections_welding_procedures, "name"),
    project_qa_welding_inspections_welding_types: _.orderBy(state.project_qa_welding_inspections_welding_types, "name"),
    project_qa_welding_inspections_welding_processes: _.orderBy(state.project_qa_welding_inspections_welding_processes, "name"),
    project_qa_welding_inspections_welding_stages: _.orderBy(state.project_qa_welding_inspections_welding_stages, "name"),
    project_qa_welding_inspections_welding_standards: _.orderBy(state.project_qa_welding_inspections_welding_standards, "name"),
    project_qa_welding_inspections_fillet_sizes: _.orderBy(state.project_qa_welding_inspections_fillet_sizes, "name"),
    project_qa_welding_inspections_access_restrictions: _.orderBy(state.project_qa_welding_inspections_access_restrictions, "name"),
    project_qa_welding_inspections_viewing_conditions: _.orderBy(state.project_qa_welding_inspections_viewing_conditions, "name"),
    project_qa_welding_inspections_surface_conditions: _.orderBy(state.project_qa_welding_inspections_surface_conditions, "name"),
  };
};

export class WeldDetails extends Component {
  constructor(props) {
    super(props);

    this.props.getProjectQaWeldingInspectionsWeldingTypes();
    this.props.getProjectQaWeldingInspectionsWeldingProcesses();
    this.props.getProjectQaWeldingInspectionsWeldingStages();
    this.props.getProjectQaWeldingInspectionsWeldingStandards();
    this.props.getProjectQaWeldingInspectionsFilletSizes();

    this.props.getProjectQaWeldingInspectionsAccessRestrictions();
    this.props.getProjectQaWeldingInspectionsViewingConditions();
    this.props.getProjectQaWeldingInspectionsSurfaceConditions();

    this.props.getEmployees();
    this.props.getProjectQaWeldingInspectionsWeldingProcedures();

    this.goToNext = this.goToNext.bind(this);
  }

  goToNext() {
    const { nextTab, handleSubmit, errors } = this.props;

    const fields = [
      "fillet_sizes_attributes",
      "welding_processes_attributes",
      "welding_stages_attributes",
      "welding_type_id",
      "welding_standard_id",
      "viewing_condition_id",
      "surface_condition_id",
      "access_restriction_id",
    ];

    const tabHasErrors = _.includes(_.keys(errors), fields);

    if (_.isNotEmpty(tabHasErrors)) {
      handleSubmit();
    } else {
      nextTab();
    }
  }

  render() {
    const {
      project_qa_welding_inspections_welding_types,
      project_qa_welding_inspections_welding_processes,
      project_qa_welding_inspections_welding_stages,
      project_qa_welding_inspections_welding_standards,
      project_qa_welding_inspections_access_restrictions,
      project_qa_welding_inspections_viewing_conditions,
      project_qa_welding_inspections_surface_conditions,
      project_qa_welding_inspections_fillet_sizes,
      employees,
      project_qa_welding_inspections_welding_procedures,
      prevTab,
      form: { change },
      values: { welding_type_id },
    } = this.props;

    const project_qa_welding_inspections_welding_procedures_sorted = _.orderBy(
      project_qa_welding_inspections_welding_procedures,
      [(item) => parseInt(item?.name?.replace(/^\D+/g, "")), "name"],
      ["asc", "asc"]
    );
    const project_qa_welding_inspections_fillet_sizes_sorted = _.orderBy(
      project_qa_welding_inspections_fillet_sizes,
      [(item) => parseInt(item?.name?.replace(/^\D+/g, "")), "name"],
      ["asc", "asc"]
    );

    const default_welding_standard = _.find(project_qa_welding_inspections_welding_standards, (ar) => ar.default);
    const default_welding_type = _.find(project_qa_welding_inspections_welding_types, (ar) => ar.default);

    const default_surface_condition = _.find(project_qa_welding_inspections_surface_conditions, (ar) => ar.default);
    const default_viewing_condition = _.find(project_qa_welding_inspections_viewing_conditions, (ar) => ar.default);
    const default_access_restriction = _.find(project_qa_welding_inspections_access_restrictions, (ar) => ar.default);

    const selected_welding_type = project_qa_welding_inspections_welding_types[welding_type_id];
    const hide_fillet_sizes = selected_welding_type?.hide_fillet_sizes;

    return (
      <Fragment>
        <BlockTitle>1. Conditions & Access</BlockTitle>

        <List>
          <Field
            name="access_restriction_id"
            component={SmartSelect}
            options={_.map(project_qa_welding_inspections_access_restrictions, (ar) => {
              return { label: ar.name, value: ar.id };
            })}
            labelName="label"
            valueName="value"
            label="Access Restrictions"
            slot="list"
            defaultValue={default_access_restriction?.id}
            validate={required}
          />

          <OnChange name="access_restriction_id">
            {(value, previous) => {
              const selected_access_restriction = project_qa_welding_inspections_access_restrictions[value];
              if (selected_access_restriction?.voids_inspection) {
                alert("This access restriction voids the inspection");
                change("complies", false);
              }
            }}
          </OnChange>

          <Field
            name="surface_condition_id"
            component={SmartSelect}
            options={_.map(project_qa_welding_inspections_surface_conditions, (sc) => {
              return { label: sc.name, value: sc.id };
            })}
            labelName="label"
            valueName="value"
            label="Surface Conditions"
            slot="list"
            defaultValue={default_surface_condition?.id}
            validate={required}
          />
          <OnChange name="surface_condition_id">
            {(value, previous) => {
              const selected_surface_condition_id = project_qa_welding_inspections_surface_conditions[value];
              if (selected_surface_condition_id?.voids_inspection) {
                alert("This surface condition voids the inspection");
                change("complies", false);
              }
            }}
          </OnChange>

          <Field
            name="viewing_condition_id"
            component={SmartSelect}
            options={_.map(project_qa_welding_inspections_viewing_conditions, (vc) => {
              return { label: vc.name, value: vc.id };
            })}
            labelName="label"
            valueName="value"
            label="Viewing Conditions"
            slot="list"
            defaultValue={default_viewing_condition?.id}
            validate={required}
          />
        </List>

        <div>
          <BlockTitle>2. Welding Details</BlockTitle>

          <List>
            <Field
              name="welding_type_id"
              label="Welding Types"
              component={SmartSelect}
              options={_.map(project_qa_welding_inspections_welding_types, (wt) => {
                return { label: wt.name, value: wt.id };
              })}
              labelName="label"
              valueName="value"
              openIn="popover"
              slot="list"
              defaultValue={default_welding_type?.id}
            />
            {!hide_fillet_sizes && (
              <Field
                label="Fillet Sizes"
                name="fillet_sizes_attributes"
                component={SmartSelect}
                validate={required}
                options={_.map(project_qa_welding_inspections_fillet_sizes_sorted, (wp) => {
                  return { label: wp.name, value: wp.id, fillet_size_id: wp.id };
                })}
                multi
                openIn="popover"
                labelName="label"
                valueName="value"
                slot="list"
              />
            )}

            <Field
              component={SmartSelect}
              validate={required}
              name="welding_processes_attributes"
              options={_.map(project_qa_welding_inspections_welding_processes, (wp) => {
                return { label: wp.name, value: wp.id, welding_process_id: wp.id };
              })}
              multi
              openIn="popover"
              label="Welding Process/es"
              slot="list"
              labelName="label"
              valueName="value"
            />

            <Field
              component={SmartSelect}
              validate={required}
              name="welding_stages_attributes"
              options={_.map(project_qa_welding_inspections_welding_stages, (sc) => {
                return { label: sc.name, value: sc.id, welding_stage_id: sc.id };
              })}
              multi
              openIn="popover"
              label="Welding Stage/s"
              slot="list"
              labelName="label"
              valueName="value"
            />

            <Field
              component={SmartSelect}
              name="welders_attributes"
              options={_.map(_.orderBy(employees, ["last_name", "first_name"]), (emp) => {
                return {
                  label: emp.display_name,
                  value: emp.id,
                  employee_id: emp.id,
                };
              })}
              multi
              validate={(this_value, all_values) => {
                const selected_access_restriction = project_qa_welding_inspections_access_restrictions[all_values?.access_restriction_id];
                const selected_surface_condition = project_qa_welding_inspections_surface_conditions[all_values?.surface_condition_id];
                const voided_inspection = selected_access_restriction?.voids_inspection || selected_surface_condition?.voids_inspection;

                if (voided_inspection) {
                  return false;
                } else {
                  if (_.isEmpty(this_value)) {
                    return "is required";
                  } else {
                    return false;
                  }
                }
              }}
              searchbar
              searchbarPlaceholder="Search Welders"
              label="Welders"
              labelName="label"
              valueName="value"
              slot="list"
            />
            <Field
              component={SmartSelect}
              label="Welding Procedure"
              name="welding_procedure_id"
              labelName="label"
              valueName="value"
              slot="list"
              options={_.map(project_qa_welding_inspections_welding_procedures_sorted, (wps) => {
                return {
                  label: wps.name,
                  value: wps.id,
                  favourite: wps.favourite,
                };
              })}
              favourite_id="favourite"
              parse={(v) => v}
              isClearable
              validate={(this_value, all_values, this_field) => {
                if (!all_values?.complies && !this_value) {
                  return "is required";
                } else {
                  return false;
                }
              }}
              searchbar
              searchbarPlaceholder="Search WPS's"
            />
          </List>
        </div>

        <BlockTitle>3. Welding Standards</BlockTitle>
        <List>
          <Field
            component={SmartSelect}
            validate={required}
            name="welding_standard_id"
            options={_.map(project_qa_welding_inspections_welding_standards, (sc) => {
              return { label: sc.name, value: sc.id };
            })}
            defaultValue={default_welding_standard?.id}
            label="Welding Standards"
            slot="list"
            labelName="label"
            valueName="value"
            openIn="popover"
          />
        </List>
      </Fragment>
    );
  }
}

export default connect(mapStateToProps, {
  getEmployees,
  getProjectQaWeldingInspectionsWeldingProcedures,
  getProjectQaWeldingInspectionsWeldingTypes,
  getProjectQaWeldingInspectionsWeldingProcesses,
  getProjectQaWeldingInspectionsWeldingStages,
  getProjectQaWeldingInspectionsWeldingStandards,
  getProjectQaWeldingInspectionsFilletSizes,
  getProjectQaWeldingInspectionsAccessRestrictions,
  getProjectQaWeldingInspectionsViewingConditions,
  getProjectQaWeldingInspectionsSurfaceConditions,
})(WeldDetails);
